import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';

const ScreenBackV2 = ({
  color = 'secondary',
  fontSize = 'medium',
  sxClr = null,
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <IconButton
      aria-label='Screenback'
      color={color}
      onClick={handleBackClick}
      sx={{
        ...(sxClr && { color: sxClr }),
      }}
    >
      <ArrowBackIcon fontSize={fontSize} />
    </IconButton>
  );
};
export const ScreenBackV2WithTitle = ({
  color = 'secondary',
  fontSize = 'medium',
  title,
  action,
  handleBackClick,
}) => {
  const navigate = useNavigate();
  const handleDefaultBackClick = () => navigate(-1);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: '2rem' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <IconButton
          aria-label='Screenback'
          color={color}
          onClick={handleBackClick || handleDefaultBackClick}
          sx={{ marginRight: 2, marginLeft: -1 }}
        >
          <ArrowBackIcon fontSize={fontSize} />
        </IconButton>
        <Typography
          variant='h5'
          color={'white'}
          fontSize={'2rem'}
        >
          {title}
        </Typography>
      </Box>
      <Box>{action && <Box sx={{ mt: 2 }}>{action}</Box>}</Box>
    </Box>
  );
};

export default ScreenBackV2;
